import { render, staticRenderFns } from "./ApartmentForm.vue?vue&type=template&id=75b8c253&"
import script from "./ApartmentForm.vue?vue&type=script&lang=js&"
export * from "./ApartmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports